import FJActionConstant from "../../constant/FJActionConstant";
import FJConfig from "../../config/FJConfig";

const initState = {
  selectedType: "",
  fontFamily: FJConfig.fontFamily,
  disableBold: false,
  disableItalic: false,
  cropMode: false,
  cropMaskType: 0,
  isEditMode: false,
  isShowEditMode: false,
  couldMask: false,
	opacityValue: 100
};

export default function (state = initState, action) {
  switch (action.type) {
    case FJActionConstant.SET_EDIT_MODE:
      return  {
        ...state,
        isEditMode: action.isEditMode,
      };
    case FJActionConstant.TOOLBAR_TYPE_CHANGED:
      return  {
        ...state,
        selectedType: action.selectedType,
      };
    case FJActionConstant.UPDATE_FONTFAMILY:
      return {
        ...state,
        fontFamily: action.fontFamily,
        disableBold: action.disableBold,
        disableItalic: action.disableItalic,
      };
    case FJActionConstant.SET_CROP_MODE:
      return {
        ...state,
        cropMode: action.cropMode,
      }
    case FJActionConstant.SET_MASK_TYPE:
      return {
        ...state,
        cropMaskType: action.maskType,
      }
    case FJActionConstant.SET_MASK_ENABLE:
      return {
        ...state,
        couldMask: action.couldMask,
      }
    case FJActionConstant.SET_SHOW_EDIT_MODE:
      return  {
        ...state,
        isShowEditMode: action.isShowEditMode,
      };
		case FJActionConstant.SET_MEDIA_OPACITY_VALUE:
			return  {
				...state,
				opacityValue: action.opacityValue
			}
    default:
      return state;
  }
}
